import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  ConnectionAttempt,
  OnboardingStatus,
} from '../models/connection-attempt.model';

@Injectable({
  providedIn: 'root',
})
export class HomeChargerStateService {
  readonly connectionAttempt = new BehaviorSubject<
    ConnectionAttempt | undefined
  >(undefined);
  readonly nextStepButtonDisabled = new BehaviorSubject<boolean>(false);
  readonly templateCheckError = new BehaviorSubject<boolean>(false);
  readonly redirectToCheckConnectionStep = new BehaviorSubject<boolean>(false);
  readonly addAddressFormInvalid = new BehaviorSubject<boolean>(false);
  readonly onboardingStatus = new BehaviorSubject<OnboardingStatus | undefined>(
    undefined
  );

  resetState(): void {
    this.connectionAttempt.next(undefined);
    this.nextStepButtonDisabled.next(false);
    this.templateCheckError.next(false);
    this.addAddressFormInvalid.next(false);
    this.onboardingStatus.next(undefined);
  }
}
